import { render, staticRenderFns } from "./PageWithBackBtn.vue?vue&type=template&id=18224ac3&scoped=true"
import script from "./PageWithBackBtn.vue?vue&type=script&lang=js"
export * from "./PageWithBackBtn.vue?vue&type=script&lang=js"
import style0 from "./PageWithBackBtn.vue?vue&type=style&index=0&id=18224ac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18224ac3",
  null
  
)

export default component.exports